import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hwdi-development-partnership',
  templateUrl: './development-partnership.component.html',
  styleUrls: ['./development-partnership.component.scss']
})
export class DevelopmentPartnershipComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
